import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/map';
import { timeout } from "rxjs/operator/timeout";


@Injectable()
export class OriginService {
    http: Http;

    origenDataChange = new Subject<void>();
    origen = [];
    private origenData = [];


    constructor(http: Http) {
        this.http = http;
    }


    fetchOrigenToday(media) {
        this.http.get(`/api/origen-today/${media}`)
            .map((response: Response) => {
                const data = response.json();
                this.origen = [
                    [
                        {
                            "name": "Sobremesa",
                            "series": [
                                {
                                    "name": "Orgánico",
                                    "value": data.sobremesa
                                },
                                {
                                    "name": "Pago",
                                    "value": 0
                                }
                            ]
                        }
                    ],
                    [
                        {
                            "name": "Móvil",
                            "series": [
                                {
                                    "name": "Orgánico",
                                    "value": data.mobile
                                },
                                {
                                    "name": "Pago",
                                    "value": 0
                                },
                                {
                                    "name": "MAT",
                                    "value": data.totalMat
                                },
				{
				    "name": "MAT Conversions",
				    "value": (data.totalMat - data.uniqueMat)
				}
                            ]
                        }
                    ],
                    [
                        {
                            "name": "Dispositivos",
                            "series": [
                                {
                                    "name": "Móvil",
                                    "value": data.mobile
                                },
                                {
                                    "name": "Sobremesa",
                                    "value": data.sobremesa
                                }
                            ]
                        }
                    ],
                    [
                        {
                            "moment": data.moment
                        }
                    ]
                ];
                return this.origen;
            })
            .subscribe(
            (data) => {
                this.origenData = data;
                // console.log(this.origenData);
                setTimeout(() => this.origenDataChange.next(), 1000 * 8);
            }
            );
    }
    fetchOriginTodayDesktop() {
        return this.origenData[0];
    }
    fetchOriginTodayMovil() {
        return this.origenData[1];
    }
    fetchOriginTodayDevices() {
        return this.origenData[2];
    }
    fetchOriginTodayMoment() {
        return this.origenData[3];
    }

}



// WEBPACK FOOTER //
// /home/node/src/app/_services/origin.service.ts